import React, { useState, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import commentIcon from "../../../../assets/svg/comment.svg";
import vector71Icon from "../../../../assets/svg/Vector 71.svg";
import viewIcon from "../../../../assets/svg/view.svg";
import {
  Form,
  Image,
  Grid,
  Table,
  Icon,
  Button,
  Comment,
  CommentGroup,
  GridColumn,
  CommentMetadata,
  GridRow,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Segment,
  Divider,
  Header,
  List,
  Message,
  Popup,
} from "semantic-ui-react";

import { useFormik } from "formik";
import { Effluentform, Form as FormApi, AuditLog } from "../../../../api";
const auditLogController = new AuditLog();
import { useAuth } from "../../../../hooks";
import { PERIODS } from "../../../../utils";

import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./EffluentForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./EffluentForm.scss";

import { useLanguage } from "../../../../contexts";
import { determineEffluentUnits } from "../../../../utils/dataAndFormulas/effluentForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify

const MAX_INVOICE_FILES = 20;
const MAX_INVOICE_FILE_SIZE = 10 * 1024 * 1024; // 10 MB, igual que el backend
import { isAdmin, isEditor, isReviewer, isMaster } from "../../../../utils/checkPermission";

const effluentFormController = new Effluentform();

export function EffluentForm(props) {
  const {
    onClose,
    onReload,
    effluentForm,
    siteSelected,
    year,
    period,
    configFormData,
    unitsRecorded,
  } = props;

  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [newFiles, setNewFiles] = useState({});
  const [unitEditEnabled, setUnitEditEnabled] = useState(false);

  // Lector de documentos de efluentes
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceResults, setInvoiceResults] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const invoiceInputRef = useRef(null);

  const { user } = useAuth();

  // Verificar si el usuario puede editar unidades (admin o master)
  const canEditUnits = isAdmin(user.role) || isMaster(user.role);

  // const location = useLocation();
  // const { siteSelected } = location.state || {};

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!siteSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateSite = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")}  ${data}`);
    onOpenCloseModal();
  };

  function setNestedError(obj, path, value) {
    const keys = path.split("."); // ["natural_gas", "unit"]
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value; // asigna el mensaje de error al último nivel
      } else {
        if (!current[key]) current[key] = {}; // crea objeto si no existe
        current = current[key]; // baja al siguiente nivel
      }
    });
  }

  // Helper function to get approval status styling
  const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
    backgroundColor:
      approvalStatus === "approved" ? "#d4edda" :
      approvalStatus === "rejected" ? "#f8d7da" :
      approvalStatus === "pending" ? "#fff3cd" : "white",
    color:
      approvalStatus === "approved" ? "#155724" :
      approvalStatus === "rejected" ? "#721c24" :
      approvalStatus === "pending" ? "#856404" : "black",
    fontWeight: "bold",
    opacity: isDisabled ? 0.9 : 1
  });

  // Helper function para limpiar el valor 0 cuando se hace focus en el campo
  const handleFocusNumberInput = (e) => {
    const value = e.target.value;
    if (value === "0" || value === 0) {
      e.target.value = "";
    }
  };

  const formik = useFormik({
    initialValues: initialValues(effluentForm, period, year, unitsRecorded),
    // validationSchema: validationSchema(),

    validate: (values) => {
      const errors = {};
      try {
        validationSchema().validateSync(values, { abortEarly: false });
      } catch (err) {
        if (err.inner && err.inner.length > 0) {
          err.inner.forEach((e) => {
            errors[e.path] = e.message;
            setNestedError(errors, e.path, e.message);
            formik.setFieldTouched(e.path, true, false);
          });

          // 🔹 Mostrar toast resumido
          const fields = err.inner
            .map((e) => {
              if (e.path.includes(".unit"))
                return `${t("unit")} (${t(e.path.split(".")[0])})`;
              if (e.path.includes(".value"))
                return `${t("value")} (${t(e.path.split(".")[0])})`;
              return t(e.path);
            })
            .join(", ");
          toast.error(`Faltan completar datos: ${t(fields)}`);

          // 🔹 Scroll automático al primer error
          // 🔹 Scroll automático al primer error
          const firstErrorPath = err.inner[0]?.path;
          if (firstErrorPath) {
            const fieldId = firstErrorPath.replace(/\./g, "_");
            let fieldEl =
              document.getElementById(fieldId) ||
              document.querySelector(`[name="${firstErrorPath}"]`);

            if (!fieldEl) {
              fieldEl = Array.from(
                document.querySelectorAll("input, select, textarea")
              ).find(
                (el) =>
                  el.name?.includes(firstErrorPath) || el.id?.includes(fieldId)
              );
            }

            if (fieldEl) {
              // Buscar el contenedor con scroll
              let scrollContainer = fieldEl.parentElement;
              while (
                scrollContainer &&
                scrollContainer !== document.body &&
                scrollContainer.scrollHeight <= scrollContainer.clientHeight
              ) {
                scrollContainer = scrollContainer.parentElement;
              }

              // Calcular posición
              const rect = fieldEl.getBoundingClientRect();
              const offset = 150;

              if (scrollContainer && scrollContainer !== document.body) {
                const containerRect = scrollContainer.getBoundingClientRect();
                const scrollTopTarget =
                  scrollContainer.scrollTop +
                  (rect.top - containerRect.top) -
                  offset;
                scrollContainer.scrollTo({
                  top: scrollTopTarget,
                  behavior: "smooth",
                });
              } else {
                window.scrollTo({
                  top: rect.top + window.scrollY - offset,
                  behavior: "smooth",
                });
              }

              fieldEl.focus({ preventScroll: true });
            } else {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        }
      }
      return errors;
    },

    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!effluentForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          if (user?.site) {
            formValue.site = user.site;
          } else {
            if (siteSelected) {
              formValue.site = siteSelected;
            }
            // else {
            //   // Desencriptar los datos recibidos
            //   if (!effluentForm) {
            //     const siteData = decrypt(siteSelected);
            //     formValue.site = siteData;
            //   }
            // }
          }
          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const finalData = removeNullValues(formValue);
          const response = await effluentFormController.createEffluentForm(
            accessToken,
            finalData
          );
          if (response.code && response.code === 200) {
            toast.success("Formulario guardado correctamente!.");
          }
        } else {
          // Detectar cambios de unidad para auditoría (solo admin/master)
          if (isAdmin(user.role) || isMaster(user.role)) {
            const unitChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.unit !== undefined && effluentForm[fieldName]?.unit !== undefined) {
                if (formValue[fieldName].unit !== effluentForm[fieldName].unit) {
                  unitChanges.push({
                    field: fieldName,
                    oldUnit: effluentForm[fieldName].unit,
                    newUnit: formValue[fieldName].unit,
                    oldValue: effluentForm[fieldName].value,
                    newValue: formValue[fieldName].value,
                  });
                }
              }
            }

            // Registrar cambios de unidad en auditoría
            for (const change of unitChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: effluentForm._id,
                  documentType: "effluent",
                  field: change.field,
                  oldValue: { value: change.oldValue, unit: change.oldUnit },
                  newValue: { value: change.newValue, unit: change.newUnit },
                  changeType: "unit_change",
                  changedBy: user._id,
                  site: effluentForm.site?._id || effluentForm.site,
                  company: effluentForm.company,
                  year: effluentForm.year,
                  period: effluentForm.period,
                });
              } catch (auditError) {
                console.error("Error registrando auditoría:", auditError);
              }
            }

            if (unitChanges.length > 0) {
              toast.info(`${unitChanges.length} cambio(s) de unidad registrado(s) en auditoría`);
            }
          }

          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const finalData = removeNullValues(formValue);
          const response2 = await effluentFormController.updateEffluentForm(
            accessToken,
            effluentForm._id,
            finalData
          );

          if (response2.code && response2.code === 200) {
            toast.success("Formulario guardado correctamente!.");
          }
        }
        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          onReload();
          if (onClose) {
            onClose();
          } else {
            // Después de guardar exitosamente, navegamos hacia atrás
            goBack();
          }
        }, 1000);
      } catch (error) {
        console.error(error);
      }
    },
  });

  const uploadFiles = async (filesToUpload, formValue, field) => {
    const formData = new FormData();
    Array.from(filesToUpload).forEach((file) => {
      formData.append("files", file);
    });

    // Luego de preparar los datos, puedes hacer la solicitud POST
    if (filesToUpload.length === 0) {
      //console.log("no hay archivos");
      //setErrorMessage("Por favor, selecciona al menos un archivo.");
      return;
    }

    try {
      // Realizar la solicitud POST al backend
      const response = await effluentFormController.uploadFileApi(
        accessToken,
        formData
      );
      if (response.code && response.code === 200) {
        return response.files;
      }
      return [];
    } catch (error) {
      //error
    }
  };

  function removeNullValues(obj) {
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key].hasOwnProperty("value")) {
        if (obj[key].value === "" || obj[key].value === null) {
          delete obj[key];
        }
      }
    }
    return obj;
  }

  const goBack = () => {
    navigate(`/admin/data/effluentforms`, {
      state: { siteSelected: siteSelected },
    });
  };

  const processInvoiceFiles = async (files) => {
    if (!files || files.length === 0) return;
    if (files.length > MAX_INVOICE_FILES) {
      toast.error(t("too_many_invoice_files") || `Se permiten hasta ${MAX_INVOICE_FILES} archivos por carga`);
      return;
    }
    const oversized = files.find((f) => f.size > MAX_INVOICE_FILE_SIZE);
    if (oversized) {
      toast.error(`"${oversized.name}" ${t("file_exceeds_max_size") || "supera el tamaño máximo permitido (10MB)"}`);
      return;
    }
    setInvoiceLoading(true);
    try {
      const formData = new FormData();
      files.forEach(f => formData.append("files", f));
      const result = await effluentFormController.readDocument(accessToken, formData);
      if (result.code === 200) {
        setInvoiceResults(result.results);
        setShowUploadModal(false);
        setShowInvoiceModal(true);
      } else {
        toast.error(result.msg || t("could_not_read_document"));
      }
    } catch (err) {
      toast.error(err?.msg || err?.message || t("error_processing_invoice"));
    } finally {
      setInvoiceLoading(false);
    }
  };

  const handleInvoiceFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    e.target.value = "";
    await processInvoiceFiles(files);
  };

  const handleApplyInvoiceData = (result) => {
    if (!result) return;
    if (result.volume != null) formik.setFieldValue("combined_effluents.value", result.volume);
    if (result.cost != null) formik.setFieldValue("combined_treatment_cost.value", result.cost);
    if (result.period) formik.setFieldValue("period", result.period);
    if (result.year) formik.setFieldValue("year", result.year);
    setShowInvoiceModal(false);
    toast.success(t("invoice_data_applied"));
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    (async () => {
      try {
        const response =
          await effluentFormController.getPeriodsEffluentFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        // Detectar si todos los meses del año están completos
        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
      }
    })();
  }, [formik.values.year]);

  function findActiveFieldByName(nameToFind) {
    if (
      configFormData &&
      configFormData.fields &&
      configFormData.fields.length > 0
    ) {
      return configFormData.fields.some(
        (field) => field.name === nameToFind && field.active
      );
    }
    return true;
  }

  return (
    <Form className="effluent-form" onSubmit={formik.handleSubmit}>
      {effluentForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {effluentForm.date ? formatDateView(effluentForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {effluentForm.creator_user
              ? effluentForm.creator_user.lastname
                ? effluentForm.creator_user.lastname + " " + effluentForm.creator_user.firstname
                : effluentForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!effluentForm ? (
        <>
          <Grid columns={2} divided>
            <GridRow style={{ display: "flex", gap: "20px" }}>
              {/* Año */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("year")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={years.map((year) => ({
                        key: year,
                        text: year,
                        value: year,
                      }))}
                      selection
                      onChange={(_, data) =>
                        formik.setFieldValue("year", data.value)
                      }
                      value={formik.values.year}
                      error={!!formik.errors.year && !!formik.touched.year}
                      style={{ flex: 1 }}
                      name="year"
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.year && formik.errors.year}
                  </div>
                </div>
              </GridColumn>

              {/* Periodo */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("period")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={listPeriods.map((period) => ({
                        key: period,
                        text: t(period),
                        value: period,
                      }))}
                      selection
                      value={formik.values.period}
                      onChange={(_, data) => {
                        // Actualiza el valor
                        formik.setFieldValue("period", data.value);
                        // Marca el campo como tocado (opcional)
                        formik.setFieldTouched("period", true, false);
                        // Borra el error si hay uno
                        formik.setFieldError("period", undefined);
                      }}
                      error={!!formik.errors.period && !!formik.touched.period}
                      style={{ flex: 1 }}
                      name="period"
                      disabled={yearComplete}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.period && formik.errors.period}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
          </Grid>
          {/* Mensaje de advertencia cuando el año está completo */}
          {yearComplete && !effluentForm && (
            <div
              style={{
                position: "fixed",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                maxWidth: "800px",
                zIndex: 99999,
                backgroundColor: "#fffef5",
                border: "1px solid #e8e8e8",
                borderRadius: "6px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      {/* Botón para habilitar edición de unidades (solo admin/master en modo edición) */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        {canEditUnits && effluentForm ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Button
              type="button"
              color={unitEditEnabled ? "orange" : "grey"}
              size="small"
              icon
              labelPosition="left"
              onClick={() => setUnitEditEnabled(!unitEditEnabled)}
            >
              <Icon name={unitEditEnabled ? "unlock" : "lock"} />
              {unitEditEnabled
                ? (t("disable_unit_edit") || "Deshabilitar edición de unidades")
                : (t("enable_unit_edit") || "Habilitar edición de unidades")
              }
            </Button>
            {unitEditEnabled && (
              <Message warning size="tiny" style={{ margin: 0, padding: "8px 12px" }}>
                <Icon name="warning sign" />
                {t("unit_edit_warning") || "Los cambios de unidad se registrarán en auditoría"}
              </Message>
            )}
          </div>
        ) : <div />}
        {/* <Popup
          content={t("read_invoice_tooltip") || "Leer documento"}
          trigger={
            <Form.Button
              type="button"
              color="teal"
              size="small"
              icon="file alternate"
              loading={invoiceLoading}
              onClick={() => setShowUploadModal(true)}
            />
          }
        /> */}
      </div>
      <Table
        size="small"
        className="effluent-table"
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              width="1"            >
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="4"            >
              {t("concept")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="3"            >
              {t("value")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="2"            >
              {t("unit")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="2"            >
              {t("state")}
            </Table.HeaderCell>
            <Table.HeaderCell              width="2"
            >
              {t("actions")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {findActiveFieldByName("domestic_effluents") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.domestic_effluents.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">{t("domestic_effluents")}</label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.domestic_effluents?.value &&
                    formik.touched.domestic_effluents?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.domestic_effluents.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="domestic_effluents.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "domestic_effluents.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "domestic_effluents.value",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.domestic_effluents.value}
                    error={
                      !!formik.errors.domestic_effluents?.value &&
                      !!formik.touched.domestic_effluents?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.domestic_effluents?.value &&
                        formik.touched.domestic_effluents?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.domestic_effluents?.unit &&
                    formik.touched.domestic_effluents?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.domestic_effluents.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits("domestic_effluents").map(
                      (ds) => ({
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      })
                    )}
                    selection
                    floating
                    disabled={!unitEditEnabled}
                    value={formik.values.domestic_effluents.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "domestic_effluents.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "domestic_effluents.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "domestic_effluents.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.domestic_effluents?.unit &&
                      !!formik.touched.domestic_effluents?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.domestic_effluents?.unit &&
                        formik.touched.domestic_effluents?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="domestic_effluents.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.domestic_effluents?.approvalStatus &&
                    formik.touched.domestic_effluents?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.domestic_effluents.approvalStatus}
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    disabled={isEditor(user.role)}
                    value={formik.values.domestic_effluents.approvalStatus}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "domestic_effluents.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "domestic_effluents.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "domestic_effluents.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.domestic_effluents?.approvalStatus &&
                      !!formik.touched.domestic_effluents?.approvalStatus
                    }
                    style={{
                      ...getApprovalStatusStyle(formik.values.domestic_effluents.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.domestic_effluents?.approvalStatus &&
                        formik.touched.domestic_effluents?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("domestic_effluents"),
                          "domestic_effluents"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"domestic_effluents"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("industrial_effluents") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.industrial_effluents.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">{t("industrial_effluents")}</label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.industrial_effluents?.value &&
                    formik.touched.industrial_effluents?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.industrial_effluents.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="industrial_effluents.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "industrial_effluents.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "industrial_effluents.value",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.industrial_effluents.value}
                    error={
                      !!formik.errors.industrial_effluents?.value &&
                      !!formik.touched.industrial_effluents?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.industrial_effluents?.value &&
                        formik.touched.industrial_effluents?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.industrial_effluents?.unit &&
                    formik.touched.industrial_effluents?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.industrial_effluents.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits("industrial_effluents").map(
                      (ds) => ({
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      })
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    value={formik.values.industrial_effluents.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "industrial_effluents.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "industrial_effluents.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "industrial_effluents.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.industrial_effluents?.unit &&
                      !!formik.touched.industrial_effluents?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.industrial_effluents?.unit &&
                        formik.touched.industrial_effluents?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="industrial_effluents.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.industrial_effluents?.approvalStatus &&
                    formik.touched.industrial_effluents?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.industrial_effluents.approvalStatus}
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    disabled={isEditor(user.role)}
                    value={formik.values.industrial_effluents.approvalStatus}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "industrial_effluents.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "industrial_effluents.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "industrial_effluents.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.industrial_effluents?.approvalStatus &&
                      !!formik.touched.industrial_effluents?.approvalStatus
                    }
                    style={{
                      ...getApprovalStatusStyle(formik.values.industrial_effluents.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.industrial_effluents?.approvalStatus &&
                        formik.touched.industrial_effluents?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("industrial_effluents"),
                          "industrial_effluents"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"industrial_effluents"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("combined_effluents") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.combined_effluents.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">{t("combined_effluents")}</label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.combined_effluents?.value &&
                    formik.touched.combined_effluents?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.combined_effluents.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="combined_effluents.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "combined_effluents.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "combined_effluents.value",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.combined_effluents.value}
                    error={
                      !!formik.errors.combined_effluents?.value &&
                      !!formik.touched.combined_effluents?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.combined_effluents?.value &&
                        formik.touched.combined_effluents?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.combined_effluents?.unit &&
                    formik.touched.combined_effluents?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.combined_effluents.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits("combined_effluents").map(
                      (ds) => ({
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      })
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    value={formik.values.combined_effluents.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "combined_effluents.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "combined_effluents.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "combined_effluents.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.combined_effluents?.unit &&
                      !!formik.touched.combined_effluents?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.combined_effluents?.unit &&
                        formik.touched.combined_effluents?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="combined_effluents.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.combined_effluents?.approvalStatus &&
                    formik.touched.combined_effluents?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.combined_effluents.approvalStatus}
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    disabled={isEditor(user.role)}
                    value={formik.values.combined_effluents.approvalStatus}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "combined_effluents.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "combined_effluents.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "combined_effluents.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.combined_effluents?.approvalStatus &&
                      !!formik.touched.combined_effluents?.approvalStatus
                    }
                    style={{
                      ...getApprovalStatusStyle(formik.values.combined_effluents.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.combined_effluents?.approvalStatus &&
                        formik.touched.combined_effluents?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("combined_effluents"),
                          "combined_effluents"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"combined_effluents"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("sludge_and_mud") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.sludge_and_mud.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">{t("sludge_and_mud")}</label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.sludge_and_mud?.value &&
                    formik.touched.sludge_and_mud?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.sludge_and_mud.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="sludge_and_mud.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "sludge_and_mud.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError("sludge_and_mud.value", undefined);
                      }
                    }}
                    value={formik.values.sludge_and_mud.value}
                    error={
                      !!formik.errors.sludge_and_mud?.value &&
                      !!formik.touched.sludge_and_mud?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.sludge_and_mud?.value &&
                        formik.touched.sludge_and_mud?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.sludge_and_mud?.unit &&
                    formik.touched.sludge_and_mud?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.sludge_and_mud.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits("sludge_and_mud").map(
                      (ds) => ({
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      })
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    value={formik.values.sludge_and_mud.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue("sludge_and_mud.unit", data.value);
                      formik.setFieldTouched(
                        "sludge_and_mud.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("sludge_and_mud.unit", undefined);
                      }
                    }}
                    error={
                      !!formik.errors.sludge_and_mud?.unit &&
                      !!formik.touched.sludge_and_mud?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.sludge_and_mud?.unit &&
                        formik.touched.sludge_and_mud?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="sludge_and_mud.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.sludge_and_mud?.approvalStatus &&
                    formik.touched.sludge_and_mud?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.sludge_and_mud.approvalStatus}
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    disabled={isEditor(user.role)}
                    value={formik.values.sludge_and_mud.approvalStatus}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "sludge_and_mud.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "sludge_and_mud.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "sludge_and_mud.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.sludge_and_mud?.approvalStatus &&
                      !!formik.touched.sludge_and_mud?.approvalStatus
                    }
                    style={{
                      ...getApprovalStatusStyle(formik.values.sludge_and_mud.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.sludge_and_mud?.approvalStatus &&
                        formik.touched.sludge_and_mud?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("sludge_and_mud"), "sludge_and_mud");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"sludge_and_mud"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("recycled_effluents") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.recycled_effluents.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">{t("recycled_effluents")}</label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.recycled_effluents?.value &&
                    formik.touched.recycled_effluents?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.recycled_effluents.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="recycled_effluents.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "recycled_effluents.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "recycled_effluents.value",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.recycled_effluents.value}
                    error={
                      !!formik.errors.recycled_effluents?.value &&
                      !!formik.touched.recycled_effluents?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.recycled_effluents?.value &&
                        formik.touched.recycled_effluents?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.recycled_effluents?.unit &&
                    formik.touched.recycled_effluents?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.recycled_effluents.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits("recycled_effluents").map(
                      (ds) => ({
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      })
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    value={formik.values.recycled_effluents.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "recycled_effluents.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "recycled_effluents.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "recycled_effluents.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.recycled_effluents?.unit &&
                      !!formik.touched.recycled_effluents?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.recycled_effluents?.unit &&
                        formik.touched.recycled_effluents?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="recycled_effluents.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.recycled_effluents?.approvalStatus &&
                    formik.touched.recycled_effluents?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.recycled_effluents.approvalStatus}
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    disabled={isEditor(user.role)}
                    value={formik.values.recycled_effluents.approvalStatus}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "recycled_effluents.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "recycled_effluents.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "recycled_effluents.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.recycled_effluents?.approvalStatus &&
                      !!formik.touched.recycled_effluents?.approvalStatus
                    }
                    style={{
                      ...getApprovalStatusStyle(formik.values.recycled_effluents.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.recycled_effluents?.approvalStatus &&
                        formik.touched.recycled_effluents?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("recycled_effluents"),
                          "recycled_effluents"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"recycled_effluents"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("treatment_cost_domestic_effluents") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.treatment_cost_domestic_effluents.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">
                  {t("treatment_cost_domestic_effluents")}
                </label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.treatment_cost_domestic_effluents?.value &&
                    formik.touched.treatment_cost_domestic_effluents?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.treatment_cost_domestic_effluents.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="treatment_cost_domestic_effluents.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "treatment_cost_domestic_effluents.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "treatment_cost_domestic_effluents.value",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.treatment_cost_domestic_effluents.value
                    }
                    error={
                      !!formik.errors.treatment_cost_domestic_effluents
                        ?.value &&
                      !!formik.touched.treatment_cost_domestic_effluents?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.treatment_cost_domestic_effluents
                          ?.value &&
                        formik.touched.treatment_cost_domestic_effluents?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.treatment_cost_domestic_effluents?.unit &&
                    formik.touched.treatment_cost_domestic_effluents?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.treatment_cost_domestic_effluents.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits(
                      "treatment_cost_domestic_effluents"
                    ).map((ds) => ({
                      key: ds.key,
                      text: t(ds.name),
                      value: ds.value,
                    }))}
                    selection
                    disabled={!unitEditEnabled}
                    value={formik.values.treatment_cost_domestic_effluents.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "treatment_cost_domestic_effluents.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "treatment_cost_domestic_effluents.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "treatment_cost_domestic_effluents.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.treatment_cost_domestic_effluents?.unit &&
                      !!formik.touched.treatment_cost_domestic_effluents?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.treatment_cost_domestic_effluents?.unit &&
                        formik.touched.treatment_cost_domestic_effluents?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="treatment_cost_domestic_effluents.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.treatment_cost_domestic_effluents
                    ?.approvalStatus &&
                    formik.touched.treatment_cost_domestic_effluents
                      ?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors.treatment_cost_domestic_effluents
                            .approvalStatus
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    value={
                      formik.values.treatment_cost_domestic_effluents.approvalStatus
                    }
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "treatment_cost_domestic_effluents.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "treatment_cost_domestic_effluents.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "treatment_cost_domestic_effluents.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.treatment_cost_domestic_effluents
                        ?.approvalStatus &&
                      !!formik.touched.treatment_cost_domestic_effluents
                        ?.approvalStatus
                    }
                    style={{
                      borderColor:
                        formik.errors.treatment_cost_domestic_effluents
                          ?.approvalStatus &&
                        formik.touched.treatment_cost_domestic_effluents
                          ?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("treatment_cost_domestic_effluents"),
                          "treatment_cost_domestic_effluents"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"treatment_cost_domestic_effluents"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("industrial_effluent_treatment_cost") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.industrial_effluent_treatment_cost.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">
                  {t("industrial_effluent_treatment_cost")}
                </label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.industrial_effluent_treatment_cost?.value &&
                    formik.touched.industrial_effluent_treatment_cost
                      ?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.industrial_effluent_treatment_cost.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="industrial_effluent_treatment_cost.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "industrial_effluent_treatment_cost.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "industrial_effluent_treatment_cost.value",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.industrial_effluent_treatment_cost.value
                    }
                    error={
                      !!formik.errors.industrial_effluent_treatment_cost
                        ?.value &&
                      !!formik.touched.industrial_effluent_treatment_cost?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.industrial_effluent_treatment_cost
                          ?.value &&
                        formik.touched.industrial_effluent_treatment_cost?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.industrial_effluent_treatment_cost?.unit &&
                    formik.touched.industrial_effluent_treatment_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.industrial_effluent_treatment_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits(
                      "industrial_effluent_treatment_cost"
                    ).map((ds) => ({
                      key: ds.key,
                      text: t(ds.name),
                      value: ds.value,
                    }))}
                    selection
                    disabled={!unitEditEnabled}
                    value={
                      formik.values.industrial_effluent_treatment_cost.unit
                    }
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "industrial_effluent_treatment_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "industrial_effluent_treatment_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "industrial_effluent_treatment_cost.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.industrial_effluent_treatment_cost
                        ?.unit &&
                      !!formik.touched.industrial_effluent_treatment_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.industrial_effluent_treatment_cost
                          ?.unit &&
                        formik.touched.industrial_effluent_treatment_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="industrial_effluent_treatment_cost.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.industrial_effluent_treatment_cost
                    ?.approvalStatus &&
                    formik.touched.industrial_effluent_treatment_cost
                      ?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors.industrial_effluent_treatment_cost
                            .approvalStatus
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                       disabled={isEditor(user.role)}
                    value={
                      formik.values.industrial_effluent_treatment_cost
                        .approvalStatus
                    }
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "industrial_effluent_treatment_cost.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "industrial_effluent_treatment_cost.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "industrial_effluent_treatment_cost.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.industrial_effluent_treatment_cost
                        ?.approvalStatus &&
                      !!formik.touched.industrial_effluent_treatment_cost
                        ?.approvalStatus
                    }
                 style={{
                      ...getApprovalStatusStyle(formik.values.industrial_effluent_treatment_cost.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.industrial_effluent_treatment_cost?.approvalStatus &&
                        formik.touched.industrial_effluent_treatment_cost?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("industrial_effluent_treatment_cost"),
                          "industrial_effluent_treatment_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"industrial_effluent_treatment_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("combined_treatment_cost") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.combined_treatment_cost.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">{t("combined_treatment_cost")}</label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.combined_treatment_cost?.value &&
                    formik.touched.combined_treatment_cost?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.combined_treatment_cost.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="combined_treatment_cost.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "combined_treatment_cost.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "combined_treatment_cost.value",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.combined_treatment_cost.value}
                    error={
                      !!formik.errors.combined_treatment_cost?.value &&
                      !!formik.touched.combined_treatment_cost?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.combined_treatment_cost?.value &&
                        formik.touched.combined_treatment_cost?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.combined_treatment_cost?.unit &&
                    formik.touched.combined_treatment_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.combined_treatment_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits(
                      "combined_treatment_cost"
                    ).map((ds) => ({
                      key: ds.key,
                      text: t(ds.name),
                      value: ds.value,
                    }))}
                    selection
                    disabled={!unitEditEnabled}
                    value={formik.values.combined_treatment_cost.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "combined_treatment_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "combined_treatment_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "combined_treatment_cost.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.combined_treatment_cost?.unit &&
                      !!formik.touched.combined_treatment_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.combined_treatment_cost?.unit &&
                        formik.touched.combined_treatment_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="combined_treatment_cost.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.combined_treatment_cost?.approvalStatus &&
                    formik.touched.combined_treatment_cost?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.combined_treatment_cost.approvalStatus}
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    disabled={isEditor(user.role)}
                    value={formik.values.combined_treatment_cost.approvalStatus}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "combined_treatment_cost.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "combined_treatment_cost.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "combined_treatment_cost.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.combined_treatment_cost?.approvalStatus &&
                      !!formik.touched.combined_treatment_cost?.approvalStatus
                    }
                    style={{
                      ...getApprovalStatusStyle(formik.values.combined_treatment_cost.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.combined_treatment_cost?.approvalStatus &&
                        formik.touched.combined_treatment_cost?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("combined_treatment_cost"),
                          "combined_treatment_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"combined_treatment_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("sludge_treatment_cost") ? (
            <Table.Row>
              {/* Código */}
              <Table.Cell>
                <label className="label">
                  {formik.values.sludge_treatment_cost.code}
                </label>
              </Table.Cell>

              {/* Concepto */}
              <Table.Cell>
                <label className="label">{t("sludge_treatment_cost")}</label>
              </Table.Cell>

              {/* Valor */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.sludge_treatment_cost?.value &&
                    formik.touched.sludge_treatment_cost?.value && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.sludge_treatment_cost.value}
                      </div>
                    )}
                  <Form.Input
                    type="number"
                    onFocus={handleFocusNumberInput}
                    name="sludge_treatment_cost.value"
                    onChange={(e) => {
                      const val = e.target.value;

                      // Si está vacío, setear 0; si no, convertir a número
                      formik.setFieldValue(
                        "sludge_treatment_cost.value",
                        val === "" ? 0 : Number(val)
                      );

                      // Opcional: borrar error si hay valor
                      if (val !== "") {
                        formik.setFieldError(
                          "sludge_treatment_cost.value",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.sludge_treatment_cost.value}
                    error={
                      !!formik.errors.sludge_treatment_cost?.value &&
                      !!formik.touched.sludge_treatment_cost?.value
                    }
                    style={{
                      borderColor:
                        formik.errors.sludge_treatment_cost?.value &&
                        formik.touched.sludge_treatment_cost?.value
                          ? "red"
                          : undefined,
                    }}
                    min={0} // evita números negativos
                  />
                </div>
              </Table.Cell>

              {/* Unidad */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.sludge_treatment_cost?.unit &&
                    formik.touched.sludge_treatment_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.sludge_treatment_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEffluentUnits(
                      "sludge_treatment_cost"
                    ).map((ds) => ({
                      key: ds.key,
                      text: t(ds.name),
                      value: ds.value,
                    }))}
                    selection
                    disabled={!unitEditEnabled}
                    value={formik.values.sludge_treatment_cost.unit}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "sludge_treatment_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "sludge_treatment_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "sludge_treatment_cost.unit",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.sludge_treatment_cost?.unit &&
                      !!formik.touched.sludge_treatment_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.sludge_treatment_cost?.unit &&
                        formik.touched.sludge_treatment_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="sludge_treatment_cost.unit"
                  />
                </div>
              </Table.Cell>

              {/* Estado */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {formik.errors.sludge_treatment_cost?.approvalStatus &&
                    formik.touched.sludge_treatment_cost?.approvalStatus && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.sludge_treatment_cost.approvalStatus}
                      </div>
                    )}
                  <Form.Dropdown
                    placeholder={t("select")}
                    options={[
                      {
                        key: 1,
                        value: "approved",
                        text: t("aproveed"),
                        label: { color: 'green', empty: true, circular: true }
                      },
                      {
                        key: 2,
                        value: "pending",
                        text: t("pending"),
                        label: { color: 'yellow', empty: true, circular: true }
                      },
                      {
                        key: 3,
                        value: "rejected",
                        text: t("rejected"),
                        label: { color: 'red', empty: true, circular: true }
                      },
                    ]}
                    selection
                    disabled={isEditor(user.role)}
                    value={formik.values.sludge_treatment_cost.approvalStatus}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "sludge_treatment_cost.approvalStatus",
                        data.value
                      );
                      formik.setFieldTouched(
                        "sludge_treatment_cost.approvalStatus",
                        true,
                        false
                      );
                      if (data.value !== null && data.value !== undefined) {
                        formik.setFieldError(
                          "sludge_treatment_cost.approvalStatus",
                          undefined
                        );
                      }
                    }}
                    error={
                      !!formik.errors.sludge_treatment_cost?.approvalStatus &&
                      !!formik.touched.sludge_treatment_cost?.approvalStatus
                    }
                    style={{
                      ...getApprovalStatusStyle(formik.values.sludge_treatment_cost.approvalStatus, isEditor(user.role)),
                      borderColor:
                        formik.errors.sludge_treatment_cost?.approvalStatus &&
                        formik.touched.sludge_treatment_cost?.approvalStatus
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              {/* Botones y upload */}
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="mini"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("sludge_treatment_cost"),
                          "sludge_treatment_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"sludge_treatment_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
        </Table.Body>
      </Table>

      <ToastContainer
        position="bottom-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

   <BasicModal
     show={showModal}
     onClose={() => setShowModal(false)}       // cerrar desde aquí
     title={titleModal}
     size="tiny"
     closeOnDimmerClick={false}             // evita cierre al hacer clic fuera
     closeOnEscape={false}                   // opcional
   >
     
     <div onClick={(e) => e.stopPropagation()}>
       <Comments
         formik={formik}
         fieldName={fieldName}
         onClose={() => setShowModal(false)}  // cerrar solo con botón
         onReload={onReload}                  // si necesitas recargar datos
         effluentForm={effluentForm}
         user={user}
         t={t}
       />
     </div>
   </BasicModal> 
      <div
        style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", alignItems: "center" }}
      >
        <Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={!effluentForm ? t("save") : t("update")}
        />

        <Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Button>
      </div>

      <Modal open={showUploadModal} onClose={() => !invoiceLoading && setShowUploadModal(false)} size="small" closeOnDimmerClick={!invoiceLoading} className="invoice-reader-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("read_invoice") || "Leer documento"}</Modal.Header>
        <Modal.Content>
          <InvoiceDropzone onFiles={processInvoiceFiles} loading={invoiceLoading} t={t} inputRef={invoiceInputRef} onInputChange={handleInvoiceFileChange} />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowUploadModal(false)} disabled={invoiceLoading}>{t("cancel")}</Button>
        </Modal.Actions>
      </Modal>

      <Modal open={showInvoiceModal} onClose={() => setShowInvoiceModal(false)} size="small" closeOnDimmerClick={false} className="invoice-preview-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("extracted_invoice_data") || "Datos extraídos"}</Modal.Header>
        <Modal.Content>
          {invoiceResults.length > 0 && (
            <div className="invoice-reader-preview">
              <Message info size="small" style={{ marginBottom: "1rem" }}>
                <Icon name="info circle" />
                {t("review_before_applying") || "Revisá los datos antes de aplicar. Hacé clic en Aplicar en la fila deseada."}
              </Message>
              <Table size="small" compact>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{t("file") || "Archivo"}</Table.HeaderCell>
                    <Table.HeaderCell>{t("water_volume") || "Volumen (m³)"}</Table.HeaderCell>
                    <Table.HeaderCell>{t("cost") || "Costo"}</Table.HeaderCell>
                    <Table.HeaderCell>{t("period") || "Período"}</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {invoiceResults.map((r, i) => (
                    <Table.Row key={i} negative={!!r.error}>
                      <Table.Cell>
                        <Icon name="paperclip" />
                        <span style={{ fontSize: "0.85em" }}>{r.filename}</span>
                        {r.format && <span style={{ marginLeft: "0.4rem", background: "#e8f4fd", color: "#1a6ba0", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase" }}>{r.format}</span>}
                      </Table.Cell>
                      <Table.Cell>{r.error ? <span style={{color:"red"}}>{r.error}</span> : r.volume != null ? <strong>{r.volume} m³</strong> : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}</Table.Cell>
                      <Table.Cell>{r.error ? "—" : r.cost != null ? <strong>$ {r.cost}</strong> : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}</Table.Cell>
                      <Table.Cell>{r.error ? "—" : r.period ? <strong>{r.period}/{r.year}</strong> : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}</Table.Cell>
                      <Table.Cell>
                        {!r.error && (
                          <Button size="mini" color="teal" onClick={() => handleApplyInvoiceData(r)}>
                            <Icon name="check" /> {t("apply") || "Aplicar"}
                          </Button>
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowInvoiceModal(false)}><Icon name="close" /> {t("cancel")}</Button>
        </Modal.Actions>
      </Modal>
    </Form>
  );
}

function InvoiceDropzone({ onFiles, loading, t, inputRef, onInputChange }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [], "image/*": [], "text/csv": [], "application/vnd.ms-excel": [], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], "text/plain": [] },
    multiple: true, disabled: loading, noClick: true, noKeyboard: true,
    onDrop: (accepted) => { if (accepted.length > 0) onFiles(accepted); },
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    onDropAccepted: () => setIsDragOver(false),
    onDropRejected: () => setIsDragOver(false),
  });
  return (
    <div {...getRootProps()} style={{ border: `2px dashed ${isDragOver ? "#648EBC" : "#b0c4de"}`, borderRadius: "12px", padding: "2.5rem 1.5rem", minHeight: "260px", textAlign: "center", cursor: loading ? "not-allowed" : "pointer", background: isDragOver ? "#f0f6ff" : "#fafafa", transition: "all 0.2s ease", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem" }}>
      <input {...getInputProps()} />
      <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt" multiple style={{ display: "none" }} onChange={onInputChange} />
      {loading ? (
        <><img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="sustemia" className="invoice-dropzone-spinner" /><p style={{ color: "#648EBC", fontWeight: 600 }}>{t("processing")}</p></>
      ) : (
        <><Icon name="cloud upload" size="huge" color="blue" style={{ margin: 0 }} />
          <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#333" }}>{t("drag_drop_files")}</p>
          <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>o</p>
          <Button type="button" primary onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}><Icon name="folder open outline" />{t("select_files")}</Button>
          <p style={{ margin: 0, color: "#aaa", fontSize: "0.75rem" }}>{t("supported_formats")}</p>
        </>
      )}
    </div>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
    
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted />    {console.log(review)}
        </React.Fragment>
      ))}


      {/* ✨ Form con preventDefault para evitar submit accidental */}
      <Form reply className="comments-reply-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div style={{ display: "flex", gap: "1em", marginTop: "1em", justifyContent: "center" }}>
          <Button
            type="button" // importante para no disparar submit
            content="Añadir"
            primary
            size="small"
            style={{ minWidth: 100 }}
            onClick={handleAddComment}
          />
          <Button
            type="button" // importante para no disparar submit
            content={t("close")}
            secondary
            size="small"
            style={{ minWidth: 100 }}
            onClick={onClose}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}
function EditableComment({ id, author, date, content, onSave, active, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleChange = (e) => setEditedContent(e.target.value);
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setEditedContent(content);
    setIsEditing(false);
  };
  const handleSave = () => {
    if (editedContent.trim()) {
      onSave(id, editedContent);
      setIsEditing(false);
    }
  };

  const initials = author
    ? author.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      padding: '10px 12px',
      borderRadius: '10px',
      backgroundColor: '#f4f6f9',
      marginBottom: '8px',
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#648EBC',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontWeight: '700', fontSize: '13px', color: '#1A1C40' }}>{author}</span>
          <span style={{ fontSize: '11px', color: '#999' }}>{date}</span>
        </div>
        {isEditing ? (
          <Form reply>
            <Form.TextArea value={editedContent} onChange={handleChange} rows={3} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", justifyContent: "center" }}>
              <Button type="button" icon="check" circular primary className="btn-comment-edit-action" onClick={handleSave} />
              <Button type="button" icon="times" circular secondary className="btn-comment-edit-action" onClick={handleCancel} />
            </div>
          </Form>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#333', wordBreak: 'break-word' }}>{content}</p>
            {active && (
              <Icon
                name="pencil"
                size="small"
                style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0, marginTop: '2px' }}
                onClick={handleEdit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FileViewer(props) {
  const { fileName, fileUniqueName, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileName) {
      const url = effluentFormController.getFileApi(fileUniqueName);
      setFileUrl(url);
    }
  }, [fileName]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      <List.Content floated="right">
        {" "}
        <Button
          color="red"
          onClick={() => handleRemove(fileUniqueName)}
          icon="trash alternate"
        />
      </List.Content>
      {/* //<Button onClick={handleOpenPreview}> {fileName}</Button> */}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button primary icon>
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            {/* <Button color="red" onClick={() => handleRemove(fileName)}>
            <Icon disabled name="trash alternate" /> Eliminar
          </Button> */}
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (file) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== file);
      setFilesView(updatedFiles);
      const response = await effluentFormController.deleteFileApi(
        accessToken,
        file
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      {/* <Input
        type="file"
        multiple
        icon={"paperclip"}
        onChange={handleFileUpload}
      /> */}
      <Popup
        content={t("upload_file")}
        trigger={
          <Button
            default
            size="mini"
            onClick={handleButtonClick}
            color={files.length > 0 ? "green" : "grey"}
          >
            <img src={vector71Icon} alt="upload" style={{ width: 14, height: 14, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />

      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}
      <Popup
        content={t("view_file")}
        trigger={
          <Button
            primary
            size="mini"
            onClick={closeModal}
          >
            <img src={viewIcon} alt="view" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          <List divided>
            {filesView.length > 0 && (
              <>
                <Header as="h4">Archivos existentes</Header>
                {filesView.map((filePath, index) => (
                  <List.Item key={index}>
                    <FileViewer
                      fileName={filePath.name}
                      fileUniqueName={filePath.uniqueName}
                      handleRemove={handleRemoveFile}
                      t={t}
                    />
                  </List.Item>
                ))}
              </>
            )}
            {newFiles[field] && newFiles[field].length > 0 && (
              <>
                <Header as="h4">Archivos nuevos (se guardarán al enviar)</Header>
                {newFiles[field].map((file, index) => (
                  <List.Item key={`new-${index}`}>
                    <List.Content floated="left">{file.name}</List.Content>
                    <List.Content floated="right">
                      <Button
                        color="blue"
                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                        icon="eye"
                      />
                      <Button
                        color="red"
                        onClick={() => {
                          const updatedNewFiles = newFiles[field].filter((_, i) => i !== index);
                          setNewFiles({ ...newFiles, [field]: updatedNewFiles });
                        }}
                        icon="trash alternate"
                      />
                    </List.Content>
                  </List.Item>
                ))}
              </>
            )}
            {filesView.length === 0 && (!newFiles[field] || newFiles[field].length === 0) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5em",
                  color: "#9e9e9e",
                  padding: "2em 0",
                }}
              >
                <Icon name="file outline" size="big" />
                <span>No se encontraron archivos subidos.</span>
              </div>
            )}
          </List>
          <div className="view-files-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary size="small" style={{ minWidth: 100 }} onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}
